import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { getKey } from '../utils/uid';
import { CHANGE_TOPIC } from '../Datum/types';
import { Provider } from '../Checkbox/context';
import { checkinputClass } from '../Checkbox/styles';
import Radio from './Radio';
import { isRTL } from '../config';

var RadioGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RadioGroup, _PureComponent);

  var _super = _createSuper2(RadioGroup);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    _this.handleRawChange = _this.handleRawChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(RadioGroup.prototype), "componentDidMount", this).call(this);

      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(RadioGroup.prototype), "componentWillUnmount", this).call(this);

      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "getContent",
    value: function getContent(d, index) {
      var renderItem = this.props.renderItem;

      if (typeof renderItem === 'string') {
        return d[renderItem];
      }

      if (typeof renderItem === 'function') {
        return renderItem(d, index);
      }

      return '';
    }
  }, {
    key: "handleClick",
    value: function handleClick(_val, _checked, index) {
      var _this$props = this.props,
          data = _this$props.data,
          datum = _this$props.datum;
      datum.set(data[index]);
    }
  }, {
    key: "handleRawChange",
    value: function handleRawChange(value) {
      this.props.datum.set(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          block = _this$props2.block,
          data = _this$props2.data,
          datum = _this$props2.datum,
          keygen = _this$props2.keygen,
          children = _this$props2.children,
          button = _this$props2.button,
          size = _this$props2.size;
      var rtl = isRTL();
      var className = classnames(checkinputClass('group', block && 'block', button && 'button', button === 'outline' && 'outline', button && size, rtl && 'rtl'), this.props.className);

      if (data === undefined) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className
          },
          /*#__PURE__*/
          React.createElement(Provider, {
            value: {
              onRawChange: this.handleRawChange,
              checked: datum.check.bind(datum)
            }
          }, children))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className
        }, data.map(function (d, i) {
          return (
            /*#__PURE__*/
            React.createElement(Radio, {
              checked: datum.check(d),
              disabled: datum.disabled(d),
              key: getKey(d, keygen, i),
              htmlValue: i,
              index: i,
              onChange: _this2.handleClick
            }, _this2.getContent(d, i))
          );
        }), children)
      );
    }
  }]);

  return RadioGroup;
}(PureComponent);

RadioGroup.defaultProps = {
  renderItem: function renderItem(d) {
    return d;
  }
};
export default RadioGroup;